import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { sqlServerMetadata } from 'app/registries/linked-service/sql-server-metadata';
import { ConnectionAuthKind, Metamodel } from 'shell-models-lib';
import { AmazonRdsSqlServerLinkedService } from 'app/model/linkedservice/amazon-rds-sql-server.linkedservice';

import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { getSqlServerLinkedServiceControls } from 'app/registries/consts/metadata-consts';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';

export const amazonRdsSqlServerMetadata: ILinkedServiceTypeMetadata = {
    ...sqlServerMetadata,
    supportedInTrident: true,
    supportAutoFillCopilotInput: true,
    isKnownInPipelineContext: true,
    pqoDataSourceOption: {
        kind: DataSourceOptionKind.Extension,
        resourceKind: 'AmazonRdsForSqlServer' as ResourceKind
    },
    supportedAuthKindsInTrident: [ConnectionAuthKind.Basic, ConnectionAuthKind.Windows],
    icon: {
        className: 'svg-i-100x100-aws_redshift'
    },
    type: Metamodel.modelFor(AmazonRdsSqlServerLinkedService).name,
    displayName: stringResources.AmazonRdsSqlServer_DisplayText,
    copySourceTypes: [adfModelTypeMap.amazonRdsSqlServer.copySourceType],
    supportDataFlowSource: false,
    supportDataFlowSink: false,
    supportCopyJobSource: true,
    supportCopyJobSink: false,
    dataflowSource: undefined,
    dataflowSink: undefined,
    supportScriptActivity: false, // blocked by backend
    copySinkTypes: [],
    controls: getSqlServerLinkedServiceControls(stringResources.AmazonRdsSqlServer_DisplayText)
};
